import {
  FilterField,
  FilterFieldOptions,
} from '@/fsd/shared/ui/filter-panel/types';
import styles from '../ui/MutualSettlements.module.scss';

interface IProps {
  organizationOptions: FilterFieldOptions[];
  counterpartyOptions: FilterFieldOptions[];
  filters: any;
}

export const getMutualSettlementsFiltersFields = ({
  organizationOptions,
  counterpartyOptions,
  filters,
}: IProps): FilterField[] => {
  return [
    {
      type: 'dateRange',
      key: 'date',
      label: 'Дата',
      className: styles.filterField,
    },
    {
      type: 'multiselect',
      key: 'organisation_ids',
      label: 'Организация',
      options: organizationOptions,
      className: styles.filterField,
    },
    {
      type: 'multiselect',
      key: 'counterparty_ids',
      label: 'Контрагент',
      options: counterpartyOptions,
      className: styles.filterField,
    },
    // {
    //   type: 'multiselect',
    //   key: 'status',
    //   label: 'Статус',
    //   options: [
    //     { label: 'Активен', value: 'active' },
    //     { label: 'Завершен', value: 'completed' },
    //   ],
    //   className: styles.filterField,
    // },
  ];
};
